import { financial } from '@/api/financial'
import { setting } from '@/api/services'
import { common } from '@/api/common'
import store from '@/store'
import Vue from 'vue'
import { P } from 'vue-dialog-drag'

let res = null

export const financials = {
    namespaced: true,
    state: {
        branchAccount: null,
        bankTransList: null,
        afterBalance: null,
        clientList: null,
        resolutionList: null,
        resolutionDocList: null,
        resolutionSlipList: null,
        carryOver: null,
        monthAmount: null,
        totalAmount: null,
        fsCodeList: null,
        ledgerList: null,
        ledgerPrintList: null,
        taxRepresentContractList: null,

        //대시보드
        payslipRatioList: null,
        bankTransactionStateList: null,
        standardMinimumWage: null,
        insurance4StateList: null,
        taxReportStateList: null,

        //신고현황 년별
        bankTransactionStateListYear: null,
        insurance4StateListYear: null,
        taxReportStateListYear: null,
    },
    mutations: {
        GET_BRANCH_ACCOUNT(state, payload) {
            state.branchAccount = payload.customerBankAccountList
        },
        GET_BANK_TRANSACTION(state, payload) {
            state.bankTransList = payload.bankTransList
            if (state.bankTransList) {
                state.bankTransList.forEach(item => {
                    Vue.set(item, 'edit', false)
                    Vue.set(item, 'editText', item.clientMemo)
                })
            }
            state.afterBalance = payload.afterBalance
        },
        SYNC_BANK_TRANSACTION(state, payload) {
            // 계좌거래내역 요청 및 파일업로드
        },
        DELETE_BANK_TRANSACTION(state, payload) {
            // 계좌거래내역 삭제 (현재 미사용 - 필요시 사용)
        },
        GET_CLIENT(state, payload) {
            state.clientList = payload.clientList
        },
        GET_RESOLUTION_INCEXP(state, payload) {
            state.resolutionList = payload.resolutionList
            if (state.resolutionList) {
                state.resolutionList.forEach(item => {
                    Vue.set(item, 'edit', false)
                    Vue.set(item, 'editText', item.clientAccountMemo)
                        // item.edit = false
                        // item.editText = item.clientAccountMemo
                })
            }
            state.resolutionDocList = payload.resolutionDocList
        },
        REGIST_CLIENT_MEMO(state, payload) {
            let arr = payload.resolutionIncomeExpenseIdx.split(',')
            state.resolutionList.forEach((item, i) => {
                if (arr.includes(String(item.resolutionIncomeExpenseIdx))) {
                    state.resolutionList[i].clientAccountMemo = payload.memo
                }
            })
        },
        REGIST_SERVICE_TYPE(state, payload) {
            let arr = payload.resolutionIncomeExpenseIdx.split(',')
            state.resolutionList.forEach((item, i) => {
                if (arr.includes(String(item.resolutionIncomeExpenseIdx))) {
                    state.resolutionList[i].homeServiceTypeCode = payload.serviceTypdeCode
                    state.resolutionList[i].homeServiceTypeCodeName = payload.serviceTypdeCode === '11' ? '방문요양' : '방문목욕'
                }
            })
        },
        RESOLUTION_CONFIRM(state, payload) {
            let arr = payload.resolutionIncomeExpenseIdx.split(',')
            state.resolutionList.forEach((item, i) => {
                if (arr.includes(String(item.resolutionIncomeExpenseIdx))) {
                    state.resolutionList[i].jobFlag = '2'
                }
            })
        },
        RESOLUTION_FILE(state, payload) {
            if (payload.type === 'resolutionMgmt') {
                let index = state.resolutionList.findIndex(item => String(item.resolutionIncomeExpenseIdx) === payload.idx)
                if (index !== -1) {
                    state.resolutionList[index].fileList = payload.data
                }
            } else if (payload.type === 'resolution' || payload.type === 'book') {
                let index = state.resolutionSlipList.findIndex(item => String(item.resolutionIncomeExpenseIdx) === payload.idx)
                if (index !== -1) {
                    state.resolutionSlipList[index].fileList = payload.data
                }
            } else {
                let index = state.ledgerList.findIndex(item => String(item.resolutionIncomeExpenseIdx) === payload.idx)
                if (index !== -1) {
                    state.ledgerList[index].fileList = payload.data
                }
            }
        },
        DELETE_RESOLUTION_FILE(state, payload) {
            if (payload.type === 'resolutionMgmt') {
                let index = state.resolutionList.findIndex(item => String(item.resolutionIncomeExpenseIdx) === payload.idx)
                if (index !== -1) {
                    state.resolutionList[index].fileList = null
                }
            } else if (payload.type === 'resolution' || payload.type === 'book') {
                let index = state.resolutionSlipList.findIndex(item => String(item.resolutionIncomeExpenseIdx) === payload.idx)
                if (index !== -1) {
                    state.resolutionSlipList[index].fileList = null
                }
            } else {
                let index = state.ledgerList.findIndex(item => String(item.resolutionIncomeExpenseIdx) === payload.idx)
                if (index !== -1) {
                    state.ledgerList[index].fileList = null
                }
            }
        },
        ACCOUNT_BOOK_RESOLUTION(state, payload) {
            state.resolutionSlipList = payload.resolutionSlipList //리스트
            state.resolutionDocList = payload.resolutionDocList //결의서 폼
        },
        ACCOUNT_BOOK_LIST(state, payload) {
            state.resolutionSlipList = payload.resolutionSlipList //리스트
            state.carryOver = payload.carryOver //전 이월금
            if (state.carryOver) state.carryOver.type = 'carry'
            state.totalAmount = payload.totalAmount //누계
            if (state.totalAmount) state.totalAmount.type = 'total'
            state.monthAmount = payload.monthAmount //합계
            if (state.monthAmount) state.monthAmount.type = 'month'
        },
        GENERAL_LEDGER_LIST(state, payload) {
            state.ledgerList = payload.ledgerList
            state.ledgerPrintList = payload.ledgerPrintList
        },
        TAX_REPRESENT_CONTRACT(state, payload) {
            state.taxRepresentContractList = payload.taxRepresentContractList
        },
        DELETE_REPRESENT_CONTRACT(state, payload) {
            let index = state.taxRepresentContractList.findIndex(item => item.taxRepresentContractIdx === payload)
            if (index !== -1) {
                state.taxRepresentContractList.splice(index, 1)
            }
        },
        FINANCIAL_DASH(state, payload) {
            state.payslipRatioList = payload.payslipRatioList
            state.bankTransactionStateList = payload.bankTransactionStateList
            state.standardMinimumWage = payload.standardMinimumWage
            state.insurance4StateList = payload.insurance4StateList
            state.taxReportStateList = payload.taxReportStateList
        },
        FINANCIAL_PROCESS_YEAR(state, payload) {
            state.bankTransactionStateListYear = payload.bankTransactionStateList
            state.insurance4StateListYear = payload.insurance4StateList
            state.taxReportStateListYear = payload.taxReportStateList
        }
    },
    actions: {
        // @Description 기관계좌 간편조회
        async GET_BRANCH_ACCOUNT({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await setting.get.copayment(payload)
                console.log('GET_BRANCH_ACCOUNT info', res)
                if (res.data.status === 200) {
                    commit('GET_BRANCH_ACCOUNT', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('GET_BRANCH_ACCOUNT error', error)
            }
        },
        // @Description 계좌거래내역 조회
        async GET_BANK_TRANSACTION({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await financial.get.bankTransList(payload)
                console.log('GET_BANK_TRANSACTION info', res)
                if (res.data.status === 200) {
                    commit('GET_BANK_TRANSACTION', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('GET_BANK_TRANSACTION error', error)
            }
        },
        // @Description 계좌거래내역 요청 및 파일업로드
        async SYNC_BANK_TRANSACTION({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await financial.post.syncBankTransaction(payload)
                console.log('SYNC_BANK_TRANSACTION info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    commit('SYNC_BANK_TRANSACTION', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('SYNC_BANK_TRANSACTION error', error)
            }
        },
        // @Description 계좌거래내역 삭제 - 미사용 시 삭제
        async DELETE_BANK_TRANSACTION({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await financial.delete.bankTrans(payload)
                console.log('DELETE_BANK_TRANSACTION info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    commit('DELETE_BANK_TRANSACTION', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('DELETE_BANK_TRANSACTION error', error)
            }
        },
        // @Description 거래처 조회
        async GET_CLIENT({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await financial.get.clientList(payload)
                console.log('GET_CLIENT info', res)
                if (res.data.status === 200) {
                    commit('GET_CLIENT', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('GET_CLIENT error', error)
            }
        },
        // @Description 결의서 내역 조회
        async GET_RESOLUTION_INCEXP({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await financial.get.resolutionIncexpList(payload)
                console.log('GET_RESOLUTION_INCEXP info', res)
                if (res.data.status === 200) {
                    commit('GET_RESOLUTION_INCEXP', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('GET_RESOLUTION_INCEXP error', error)
            }
        },
        // @Description 적요 수정(개별)
        async REGIST_CLIENT_MEMO({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await financial.post.resolutionClientMemo(payload)
                console.log('REGIST_CLIENT_MEMO info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    commit('REGIST_CLIENT_MEMO', payload)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('REGIST_CLIENT_MEMO error', error)
            }
        },
        // @Description 적요 수정(일괄저장)
        async REGIST_CLIENT_MEMO_SELECTED({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await financial.post.clientMemoMulti(payload)
                console.log('REGIST_CLIENT_MEMO_SELECTED info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('REGIST_CLIENT_MEMO_SELECTED error', error)
            }
        },
        // @Description 메모, 사업코드 등 한번에 저장 후 바로 수정요청
        async RESOLUTION_EDIT_APPLY({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await financial.post.resolutionChgConfirm(payload)
                console.log('RESOLUTION_EDIT_APPLY info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('RESOLUTION_EDIT_APPLY error', error)
            }
        },
        // @Description 사업코드 수정
        async REGIST_SERVICE_TYPE({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await financial.post.resolutionServiceType(payload)
                console.log('REGIST_SERVICE_TYPE info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    commit('REGIST_SERVICE_TYPE', payload)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('REGIST_SERVICE_TYPE error', error)
            }
        },
        // @Description 결의서 동기화 요청
        async RESOLUTION_CONFIRM({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await financial.post.resolutionConfirm(payload)
                console.log('RESOLUTION_CONFIRM info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    commit('RESOLUTION_CONFIRM', payload)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('RESOLUTION_CONFIRM error', error)
            }
        },
        // @Description 결의서 분개
        async RESOLUTION_JOURNALIZE({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await financial.post.resolutionJournalize(payload)
                console.log('RESOLUTION_JOURNALIZE info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('RESOLUTION_JOURNALIZE error', error)
            }
        },
        // @Description 결의서 분개 취소
        async CANCEL_JOURNALIZE({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await financial.delete.resolutionJournalize(payload)
                console.log('CANCEL_JOURNALIZE info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('CANCEL_JOURNALIZE error', error)
            }
        },
        // @Description 결의서 증빙자료 업로드
        async RESOLUTION_FILE({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await financial.post.resolutionFile(payload)
                console.log('RESOLUTION_FILE info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    commit('RESOLUTION_FILE', {
                        data: res.data.data.uploadFile,
                        idx: payload.resieIdx,
                        type: payload.type
                    })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('RESOLUTION_FILE error', error)
            }
        },
        // @Description 결의서 증빙자료 삭제
        async DELETE_RESOLUTION_FILE({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await financial.delete.resolutionFile(payload)
                console.log('DELETE_RESOLUTION_FILE info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    commit('DELETE_RESOLUTION_FILE', {
                        idx: payload.resieIdx,
                        type: payload.type
                    })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('DELETE_RESOLUTION_FILE error', error)
            }
        },
        // @Description 회계장부-결의서 조회
        async ACCOUNT_BOOK_RESOLUTION({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await financial.get.accountBookResolution(payload)
                console.log('ACCOUNT_BOOK_RESOLUTION info', res)
                if (res.data.status === 200) {
                    commit('ACCOUNT_BOOK_RESOLUTION', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('ACCOUNT_BOOK_RESOLUTION error', error)
            }
        },
        // @Description 회계장부-현금출납부 조회
        async ACCOUNT_BOOK_LIST({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await financial.get.accountBookList(payload)
                console.log('ACCOUNT_BOOK_LIST info', res)
                if (res.data.status === 200) {
                    commit('ACCOUNT_BOOK_LIST', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('ACCOUNT_BOOK_LIST error', error)
            }
        },
        // @Description 회계장부-총계정원장 조회
        async GENERAL_LEDGER_LIST({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await financial.get.generalLedgerList(payload)
                console.log('GENERAL_LEDGER_LIST info', res)
                if (res.data.status === 200) {
                    commit('GENERAL_LEDGER_LIST', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('GENERAL_LEDGER_LIST error', error)
            }
        },
        // @Description 회계장부-현금출납부, 결의서, 총계정원장 모두 조회(출력용)
        async ACCOUNT_BOOK_REPORT({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await financial.get.accountReport(payload)
                console.log('ACCOUNT_BOOK_REPORT info', res)
                if (res.data.status === 200) {
                    // commit('ACCOUNT_BOOK_REPORT', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('ACCOUNT_BOOK_REPORT error', error)
            }
        },
        // @Description 세무대리계약서 조회
        async TAX_REPRESENT_CONTRACT({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await financial.get.taxRepresentContract(payload)
                console.log('TAX_REPRESENT_CONTRACT info', res)
                if (res.data.status === 200) {
                    commit('TAX_REPRESENT_CONTRACT', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('TAX_REPRESENT_CONTRACT error', error)
            }
        },
        // @Description 세무계약서 조회
        async REPRESENT_CONTRACT_DETAIL({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await financial.get.representContract(payload)
                console.log('REPRESENT_CONTRACT_DETAIL info', res)
                if (res.data.status === 200) {

                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('REPRESENT_CONTRACT_DETAIL error', error)
            }
        },
        // @Description 세무계약서 저장
        async REGIST_REPRESENT_CONTRACT({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await financial.post.taxRepresentContract(payload)
                console.log('REGIST_REPRESENT_CONTRACT info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('REGIST_REPRESENT_CONTRACT error', error)
            }
        },
        // @Description 세무계약서 삭제
        async DELETE_REPRESENT_CONTRACT({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await financial.delete.taxRepresentContract(payload)
                console.log('DELETE_REPRESENT_CONTRACT info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                    commit('DELETE_REPRESENT_CONTRACT', payload.taxRepresentContractIdx)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('DELETE_REPRESENT_CONTRACT error', error)
            }
        },
        // @Description 세무계약서 파일 업로드
        async REGIST_REPRESENT_CONTRACT_FILE({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await financial.post.taxRepresentContractFile(payload)
                console.log('REGIST_REPRESENT_CONTRACT_FILE info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('REGIST_REPRESENT_CONTRACT_FILE error', error)
            }
        },
        // @Description W4C전송 요청
        async APPLY_W4C({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await financial.post.W4CApply(payload)
                console.log('APPLY_W4C info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                        // commit('APPLY_W4C', payload)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('APPLY_W4C error', error)
            }
        },
        // @Description 은행거래내역 메모작성 및 수정요청
        async BANK_MEMO_APPLY({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await financial.post.bankTransMemo(payload)
                console.log('BANK_MEMO_APPLY info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('BANK_MEMO_APPLY error', error)
            }
        },
        // @Description 재무회계 대시보드
        async FINANCIAL_DASH({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await financial.get.dash(payload)
                console.log('FINANCIAL_DASH info', res)
                if (res.data.status === 200) {
                    commit('FINANCIAL_DASH', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('FINANCIAL_DASH error', error)
            }
        },
        // @Description 결의서 마감완료 상태로 변경
        async EDIT_FLAG_7({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await financial.post.resolutionJobFlag(payload)
                console.log('EDIT_FLAG_7 info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('EDIT_FLAG_7 error', error)
            }
        },
        // @Description 신고현황 1년씩 조회
        async FINANCIAL_PROCESS_YEAR({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await financial.get.dashYear(payload)
                console.log('FINANCIAL_PROCESS_YEAR info', res)
                if (res.data.status === 200) {
                    commit('FINANCIAL_PROCESS_YEAR', res.data.data)
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('FINANCIAL_PROCESS_YEAR error', error)
            }
        },
        // @Description 소득세 신고 요청 처리
        async REQUEST_INCOME_TAX_TO_AGENCY({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await financial.post.taxReportReq(payload)
                console.log('REQUEST_INCOME_TAX_TO_AGENCY info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('REQUEST_INCOME_TAX_TO_AGENCY error', error)
            }
        },
        // @Description 본인부담금 게정과목 가져오기
        async GET_PERSONAL_CHARGE_DEPOSITS({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await financial.get.resolutionIncExpDeposit(payload)
                console.log('GET_PERSONAL_CHARGE_DEPOSITS info', res)
                if (res.data.status === 200) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('GET_PERSONAL_CHARGE_DEPOSITS error', error)
            }
        },
        // @Description 은행거래 상세내역 바로보기
        async GET_ACCOUNT_DETAIL_TRANSATIONS({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await financial.get.clientAccountItemTrans(payload)
                console.log('GET_ACCOUNT_DETAIL_TRANSATIONS info', res)
                if (res.data.status === 200) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('GET_ACCOUNT_DETAIL_TRANSATIONS error', error)
            }
        },
        // @Description 본인부담금 수납 및 입금처리
        async REGIST_DE0POSIT_PERSONAL_CHARGES({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await financial.post.regReceiverDeposit(payload)
                console.log('REGIST_DEPOSIT_PERSONAL_CHARGES info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('REGIST_DEPOSIT_PERSONAL_CHARGES error', error)
            }
        },
        // @Description 본인부담금 입금자명 수정하기
        async REPLACE_DEPOSITORS_NAMES({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await financial.post.depositorResieChg(payload)
                console.log('REGIST_DEPOSIT_PERSONAL_CHARGES info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('REGIST_DEPOSIT_PERSONAL_CHARGES error', error)
            }
        },
        // @Description 수급대상자 자동매칭
        async AUTO_MATCHING_WITH_RECIPIENT({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await financial.post.matchReceiverDeposit(payload)
                console.log('AUTO_MATCHING_WITH_RECIPIENT info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('AUTO_MATCHING_WITH_RECIPIENT error', error)
            }
        },
        // @Description 급여정산 및 마감 후 급여내역 가져오기
        async GET_RESOLUTION_STAFF_PAYSLIP_LIST({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await financial.get.resolutionStaffPayslip(payload)
                console.log('GET_RESOLUTION_STAFF_PAYSLIP_LIST info', res)
                if (res.data.status === 200) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('GET_RESOLUTION_STAFF_PAYSLIP_LIST error', error)
            }
        },
        // @Descripition 수급자 본인부담금 년간 입금내역 보기
        async GET_PERSONAL_CHARGE_DEPOSIT_LIST({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await financial.get.regReceiverDeposit(payload)
                console.log('GET_PERSONAL_CHARGE_DEPOSIT_LIST info', res)
                if (res.data.status === 200) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('GET_PERSONAL_CHARGE_DEPOSIT_LIST error', error)
            }
        },
        // @Description 수급자 변경하기
        async CHANGE_AN_RECIPIENT({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await financial.post.depositorReceiverChg(payload)
                console.log('CHANGE_AN_RECIPIENT info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('CHANGE_AN_RECIPIENT error', error)
            }
        },
        // @Description 급여관련 지출결의서로 생성
        async REGIST_BURSEMENT_DOCS({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await financial.post.iedocSalaryReg(payload)
                console.log('REGIST_BURSEMENT_DOCS info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('REGIST_BURSEMENT_DOCS error', error)
            }
        },
        // @Description 결의서 항목 삭제
        async DELETE_BURSEMENT_DOCS({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await financial.post.iedocSalaryDel(payload)
                console.log('DELETE_BURSEMENT_DOCS info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('DELETE_BURSEMENT_DOCS error', error)
            }
        },
        // @Description 입금자 리스트 가져오기 
        async GET_DEPOSITS_ON_BANK({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await financial.get.bankTransDeposit(payload)
                console.log('GET_DEPOSITS_ON_BANK info', res)
                if (res.data.status === 200) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('GET_DEPOSITS_ON_BANK error', error)
            }
        },
        // @Description 은행거래내역에서 입금자 등록하기 
        async REGIST_DEPOSIT_PERSONAL_CHARGES_ON_BANK({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await financial.post.bankTransDeposit(payload)
                console.log('REGIST_DEPOSIT_PERSONAL_CHARGES_ON_BANK info', res)
                if (res.data.status === 201) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('REGIST_DEPOSIT_PERSONAL_CHARGES_ON_BANK error', error)
            }
        },
        // @description 상대계정 목록 가져오기
        async GET_LIST_OF_CLIENT_MATCHING_ACCOUNT({commit}, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await financial.get.listOfClientMatchingAccount(payload)
                console.log('GET_LIST_OF_CLIENT_MATCHING_ACCOUNT info', res)
                if (res.data.status === 200) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('GET_LIST_OF_CLIENT_MATCHING_ACCOUNT error', error)
            }
        },
        // @Description 상대계정 및 자금원천 저장하기
        async UPDATE_ACCOUNT_NAME_OR_FUND_RESOURCE({ commit }, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await financial.post.updateAccountNameFunds(payload)
                console.log('UPDATE_ACCOUNT_NAME_OR_FUND_RESOURCE info', res)
                if (res.data.status === 200) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('UPDATE_ACCOUNT_NAME_OR_FUND_RESOURCE error', error)
            }
        },
        // @Description 희망이음 동기화 관련 보고서 가져오기
        async GET_HOPE_SYNC_RESULT_REPORT({commit}, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await financial.get.getTaskLogReport(payload)
                console.log('GET_HOPE_SYNC_RESULT_REPORT info', res)
                if (res.data.status === 200) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('GET_HOPE_SYNC_RESULT_REPORT error', error)
            }
        },
        // @Description 희망이음 동기화 관련 보고서 조회 유형 가져오기
        async GET_HOPE_SYNC_REPORT_TYPE({commit}, payload) {
            try {
                store.commit('OPEN_LOADING')
                res = await financial.get.getTaskSelectType(payload)
                console.log('GET_HOPE_SYNC_REPORT_TYPE info', res)
                if (res.data.status === 200) {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'success' })
                } else {
                    store.commit('OPEN_SYSTEM_BAR', { message: res.data.message, color: 'error' })
                }
                store.commit('CLOSE_LOADING')
                return res.data
            } catch (error) {
                store.commit('CLOSE_LOADING')
                console.error('GET_HOPE_SYNC_REPORT_TYPE error', error)
            }
        }
    },
    getters: {

    }
}


// WEBPACK FOOTER //
// ./src/store/modules/financials.js